import React, { useEffect } from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setUserData, setLoading, setError } from './userSlice';

export const LoadUser = () => {
  const dispatch = useDispatch();

  const { isLoading: isLoadingUser, refetch: fetchUser } = useQuery(
    "load-user",
    async () => {
      return await apiClient.get("/api/user-with-relations");
    },
    {
      enabled: true,
      onSuccess: (res) => {
        if (res.data.status === 'success') {
          dispatch(setUserData(res.data.user));
          dispatch(setLoading(false));
        }
      },
      onError: (err) => {
        dispatch(setLoading(false));
        dispatch(setError(err.response?.data?.message || 'Failed to load user data'));
      },
    }
  );

  useEffect(() => {
    dispatch(setLoading(true));
    fetchUser();
  }, []);

  return null;
}

export default LoadUser
